import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    overflow: hidden;
    flex-direction: column;
    position: absolute;
    height: 100vh;
    width: ${displayState?.isVisible ? '100vw' : '0px'};
    right: 0px;
    top: 0px;
    z-index: 1000;
    background-color: ${displayState?.isVisible && !displayState?.hideBackground ? 'rgb(4, 51, 59, 0.7)' : 'rgb(4, 51, 59, 0)'};
    backdrop-filter: blur(1px);
    transition: width 500ms ease-in-out, background-color 1500ms ease-in-out;  
  `}
`;

export default Wrapper(template);